import { Link, Navigate, useLocation } from 'react-router-dom'
import { CheckCircle2 } from 'lucide-react'
import { formatDateLong } from '@hotel/shared/utils'
import type { ReservationSummary } from '../api/types'
import { PriceBreakdown } from '../components/PriceBreakdown'

export function ConfirmationPage() {
  const location = useLocation() as { state?: { reservation?: ReservationSummary } }
  const reservation = location.state?.reservation
  if (!reservation) return <Navigate to="/" replace />

  return (
    <main className="content-section confirmation-page">
      <div className="confirmation-card">
        <CheckCircle2 className="confirmation-icon" />
        <span className="eyebrow">Reservación pendiente creada</span>
        <h1>{reservation.confirmation_code}</h1>
        <p>Tu solicitud ya está registrada en el sistema del hotel. El equipo puede validarla y continuar el seguimiento desde operación interna.</p>
        <div className="confirmation-grid">
          <div><span>Huésped</span><strong>{reservation.guest_name}</strong></div>
          <div><span>Tipo</span><strong>{reservation.room_type_name}</strong></div>
          <div><span>Llegada</span><strong>{formatDateLong(reservation.check_in_date)}</strong></div>
          <div><span>Salida</span><strong>{formatDateLong(reservation.check_out_date)}</strong></div>
          <div><span>Estado</span><strong>{reservation.status}</strong></div>
        </div>
        <PriceBreakdown pricing={reservation.pricing} />
        <Link className="primary-button link-button" to="/account">Ver mis reservas</Link>
      </div>
    </main>
  )
}
